import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export function SectionLabel({ children, dark = false, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] font-semibold ${
        dark ? "text-brandgreen" : "text-brandgreen"
      } ${className}`}
    >
      <span className="w-6 h-px bg-brandgreen inline-block" />
      {children}
    </span>
  );
}

// Inner-page hero with an image band + parallax-free clean layout.
export function PageHero({ label, title, subtitle, image, crumb }) {
  return (
    <section className="relative pt-28 lg:pt-36 pb-14 lg:pb-20 bg-navy text-white overflow-hidden grain">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-navy/70" />
        </div>
      )}
      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
        {crumb && (
          <div className="text-xs text-white/50 mb-5 tracking-wide">
            <Link to="/" className="hover:text-white">Home</Link> <span className="mx-1">/</span> {crumb}
          </div>
        )}
        {label && <SectionLabel dark className="mb-5">{label}</SectionLabel>}
        <motion.h1
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] max-w-4xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="mt-6 text-base md:text-lg text-white/70 max-w-2xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
